"use client"

import { baseTheme } from "@/utils/app/theme"
import { ConfigProvider } from "antd"
import { IconProvider } from "@ant-design/icons"

import 'dayjs/locale/vi';

import localeVi from 'antd/locale/vi_VN';
import localeEn from 'antd/locale/vi_VN';

const ICON_PREFIX_CLS = "teicon"
// `@ant-design/icons` ships CJS (server, via its "node" export condition) and
// ESM (client) builds, each with its own IconContext. antd's ConfigProvider only
// fills the ESM one, so icons imported by the app would SSR as `anticon`.
// Providing the context from the same entry the app imports covers both builds.
const ICON_CONTEXT = { prefixCls: ICON_PREFIX_CLS }

const ThemeProvider = ({ children, lang }: any) => {
  const locale: any = {
    en: localeEn,
    vi: localeVi
  }

  return (
    <ConfigProvider
      prefixCls="te"
      iconPrefixCls={ICON_PREFIX_CLS}
      locale={locale[lang]}
      theme={{
        ...baseTheme({}),
        // Stable key + no hash so SSR classNames match client (no css-dev-only-do-not-override-*).
        cssVar: {
          key: 'te',
          prefix: 'te',
        },
        hashed: false,
      }}
    >
      <IconProvider value={ICON_CONTEXT}>{children}</IconProvider>
    </ConfigProvider>
  )
}

export default ThemeProvider
